import React from 'react';
import DashboardActivityChart from '../charts/DashboardActivityChart';
import { useDashboardStatisticsAccess } from '../useDashboardStatisticsAccess';

export default function ActivityCard({
  player,
  handleId,
  loading: profileLoading,
  statisticsAccessResourceKey = null,
}) {
  const hid = Number(handleId);
  const hidOk = Number.isInteger(hid) && hid >= 1;
  const { canViewStatistics } = useDashboardStatisticsAccess(player, {
    extraReadResourceKey: statisticsAccessResourceKey,
  });

  if (!hidOk) return null;

  if (profileLoading && !player) {
    return (
      <section
        className="member-dashboard__panel-card member-dashboard__activity-card"
        aria-busy="true"
        aria-label="Activity statistics"
        data-resource="private.navbar.personalhub.activity"
        data-action="read"
        data-description="Personal hub — activity statistics"
      >
        <div className="member-dashboard__panel-card-head">
          <h2 className="member-dashboard__panel-title">Activity</h2>
        </div>
        <div className="member-dashboard__panel-card-body">
          <p className="member-dashboard__panel-placeholder">Loading…</p>
        </div>
      </section>
    );
  }

  if (!canViewStatistics) {
    return (
      <section
        className="member-dashboard__panel-card member-dashboard__activity-card"
        aria-label="Activity statistics"
        data-resource="private.navbar.personalhub.activity"
        data-action="read"
        data-description="Personal hub — activity statistics"
      >
        <div className="member-dashboard__panel-card-head">
          <h2 className="member-dashboard__panel-title">Activity</h2>
        </div>
        <div className="member-dashboard__panel-card-body">
          <p className="member-dashboard__panel-placeholder">
            You do not have permission to view activity statistics for this member.
          </p>
        </div>
      </section>
    );
  }

  return (
    <section
      className="member-dashboard__panel-card member-dashboard__activity-card"
      aria-label="Activity statistics"
      data-resource="private.navbar.personalhub.activity"
      data-action="read"
      data-description="Personal hub — activity statistics"
    >
      <DashboardActivityChart
        title="Activity"
        handleId={player?.handleId ?? handleId}
        scope="cluster"
        enabled={canViewStatistics}
      />
    </section>
  );
}
